import GameLogService from "src/services/GameLogService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {};
export const params = {
	game_id:"",
	company_id:"",
	played_at:"",

};

/**
@namespace
@property  {object} module,
@property  {object} module.state,
@property  {object} modules.gamelog,
@property  {array}  modules.gamelogs
**/

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {},
	types: types
};
export default ModuleCreator("gamelog", GameLogService, module, types ,params);
